import {
  Decoration,
  DecorationSet,
  EditorView,
  ViewPlugin,
  ViewUpdate,
} from '@codemirror/view';

const expressionPattern = /\{\{[^}]*\}\}/g;

const expressionMark = Decoration.mark({
  class: 'cm-expression',
  attributes: { title: 'Dynamic expression' },
});

function buildDecorations(view: EditorView): DecorationSet {
  const decorations: ReturnType<typeof expressionMark.range>[] = [];
  const text = view.state.doc.toString();

  // Reset regex state
  expressionPattern.lastIndex = 0;

  let match;
  while ((match = expressionPattern.exec(text)) !== null) {
    decorations.push(
      expressionMark.range(match.index, match.index + match[0].length),
    );
  }

  return Decoration.set(decorations, true);
}

/**
 * CodeMirror extension that highlights {{expression}} syntax
 * Used for dynamic template expressions in JSON and text content
 */
export const expressionHighlighting = ViewPlugin.fromClass(
  class {
    decorations: DecorationSet;

    constructor(view: EditorView) {
      this.decorations = buildDecorations(view);
    }

    update(update: ViewUpdate) {
      if (update.docChanged || update.viewportChanged) {
        this.decorations = buildDecorations(update.view);
      }
    }
  },
  {
    decorations: (v) => v.decorations,
  },
);

/**
 * CSS styles for expression highlighting
 * Applies a primary color background to {{expression}} syntax
 */
export const expressionHighlightingTheme = EditorView.baseTheme({
  '.cm-expression': {
    backgroundColor: 'rgb(var(--color-primary) / 0.15)',
    borderRadius: '2px',
    color: 'rgb(var(--color-primary))',
    fontWeight: '500',
  },
});
